module.exports = __webpack_public_path__ + "static/media/tlyfBanner.1e67234a.png";